import React from 'react';
import './social-links.css';
import ArticleIcon from '@mui/icons-material/ArticleOutlined';
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkIcon from '@mui/icons-material/Link';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import { socials } from '../../data/profile';

const ICONS = {
  linkedin: LinkedInIcon,
  github: GitHubIcon,
  twitter: TwitterIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  article: ArticleIcon,
};

function SocialLinks({ className = '', ...rest }) {
  return (
    <ul className={`social-links ${className}`.trim()} {...rest}>
      {socials.map(({ name, url, icon }) => {
        const Icon = ICONS[icon] || LinkIcon;
        return (
          <li key={name}>
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              aria-label={name}
              title={name}
            >
              <Icon fontSize="small" />
            </a>
          </li>
        );
      })}
    </ul>
  );
}

export default SocialLinks;
